import React from 'react'
import Header from '../../common/Header'
import CommonBreadcrumb from '../../common/CommonBreadcrumb'
import CommonHeroSection from '../../common/CommonHeroSection'
import Footer from '../../common/Footer'
import TicketSection from '../../sections/CommonSection/TicketSection'
import hotelBookingImg from '../../../assets/our-services-img/hotel-booking-img.jpg';

const HotelBooking = () => {
    return (
        <>
            <Header />
            <CommonHeroSection title="Hotel Booking" />
            <CommonBreadcrumb items={["Hotel Booking"]} />
            <TicketSection
                title="Hotel Booking"
                description={[
                    `Are you are searching for class-apart hotels in multiple tourist spots of Bangalore, Karnataka, then Sudarshan Holidays would be the perfect option for your search. Being one of the distinguished travel agencies in Bangalore, Karnataka, we offer exquisite hotels with comfortable accommodations with all the modern amenities in Bangalore, Karnataka.`,
                    `Being a prominent travel agency we offer 2-star, 3-star and even luxurious 5-star hotels which include king-size rooms, conference halls, parking zones, 24-hour running water, power backup, attached bathrooms, balconies and multi-cuisine restaurants. The rooms also have ample balconies to enjoy the beauty of the tourist spots.`,
                    `We at Sudarshan Holidays understand the different needs of our clients well and thus try to deliver our excellent hotel booking service as per the suitability and demands of our clients. All the hotels we offer are well-furnished with all the necessary amenities. Enjoy excellent hotel booking service with us to make your vacation stay an ever-remarkable one. Contact us now.`,
                ]}
                image={hotelBookingImg}
            />
            <Footer />
        </>
    )
}

export default HotelBooking